<template>
  <nav>
    <div class="wrapper nav-bar">
      <router-link to="/">
        <div id="nav-logo"></div>
      </router-link>
      <div class="nav-list">
        MODsight Packaging Selector - Prototype
      </div>
      <div class="nav-user">
        <!-- <font-awesome-icon
          class="icon icons-grid-info"
          :icon="['fa', 'info-circle']"
          title="View Details"
          @click="togglePNG()"
        /> -->
      </div>
      <div
        v-if="showImage"
        ref="popup"
        class="png-container"
        @keyup.esc="togglePNG()"
        @click="togglePNG()"
        tabindex="0"
      >
        <div class="image-wrapper">
          <h2>Process Overview</h2>
          <div
            class="image"
            :style="{
              'background-image':
                'url(' + require('../assets/images/supplyprocess.png') + ')'
            }"
          ></div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "theHeader",
  data() {
    return {
      showImage: false
    };
  },
  mounted() {
    window.addEventListener("keypress", e => {
      if (String.fromCharCode(e.keyCode) === "1") {
        this.togglePNG();
      }
    });
  },
  methods: {
    togglePNG() {
      if (this.showImage === false) {
        this.showImage = true;
        this.$nextTick(() => {
          this.$refs.popup.focus();
        });
      } else {
        this.showImage = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.wrapper {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

nav {
  background-color: $modum;
}

#nav-logo {
  background-image: url("../assets/images/logo.svg");
  background-position: center center;
  background-repeat: no-repeat;
  padding: 40px 0;
  height: 20px;
  width: 150px;
  &:hover {
    background-color: $modumdark;
  }
}
.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.nav-list {
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  padding-right: 110px;
}
.icons-grid-info {
  color: white;
  font-size: 20px;
  margin-right: 10px;
  cursor: pointer;
}

.png-container {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: $modumBackground;
  top: 0;
  left: 0;
  z-index: 1000;
  .image {
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    height: 500px;
    width: 600px;
  }
  .image-wrapper {
    padding: 40px;
    background-color: #fff;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    transform: translate(-50%, -50%);
    h2 {
      margin-top: 0;
    }
  }
}
</style>
